export const environment = {
    production: false,
    apiUrl: 'https://tools-php-dev.teu.com.mx/index.php',
    authorizationCode: '59e5a9a7-6884-4360-b52f-66fe35368f3d'
};
